import * as React from 'react';
import {connect} from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';

import {updateSlideElement} from 'client/actions/slideShowEditor';
import {ISlideElement, ISlideElementAdditionalFonts} from 'shared/collections/SlideElements';
import EditorSelect from 'client/components/editor/formFields/EditorSelect';
import {SlideshowFontFamily, SlideshowFontFamilyText} from 'shared/collections/Slideshows';
import {googleFonts} from 'shared/models/GoogleFonts';

interface IFontFieldProps {
	element: ISlideElement & ISlideElementAdditionalFonts;
	updateSlideElement: typeof updateSlideElement;
	name: string;
	text: string;
}

class FontField extends React.Component<IFontFieldProps> {
	handleChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
		const {element, name} = this.props;

		this.props.updateSlideElement(element, {
			[name || 'fontFamily']: event.target.value,
		});
	};

	render() {
		const {
			text,
			element,
			name,
			element: {additionalFonts = []},
		} = this.props;

		const value = element[name || 'fontFamily'];

		const googleSelectedFont = additionalFonts
			.concat(googleFonts)
			.find((family) => family === value);

		return (
			<EditorSelect
				label={text || 'Шрифт'}
				onChange={this.handleChange}
				value={value || 'Arial'}
				style={{
					fontFamily: googleSelectedFont || (value && SlideshowFontFamilyText[value]),
				}}
			>
				{additionalFonts.map((family) => (
					<MenuItem value={family} key={family} style={{fontFamily: family}}>
						{family}
					</MenuItem>
				))}

				{SlideshowFontFamily.getValues().map((fontFam, index) => (
					<MenuItem
						value={SlideshowFontFamilyText[fontFam]}
						key={index}
						style={{fontFamily: SlideshowFontFamilyText[fontFam]}}
					>
						{SlideshowFontFamilyText[fontFam]}
					</MenuItem>
				))}

				{googleFonts.map((family) => (
					<MenuItem value={family} key={family} style={{fontFamily: family}}>
						{family}
					</MenuItem>
				))}
			</EditorSelect>
		);
	}
}

export default connect(null, {
	updateSlideElement,
})(FontField);
